import { Button, Loader } from "src/ui/widgets";
import { useDataEntry } from "./data-entry.hook";
import { RightArrowIcon } from "src/assets";
import { DataEntryStep1 } from "./data-entry-step-1/data-entry-step-1";
import { DataEntryStep2 } from "./data-entry-step-2/data-entry-step-2";
import { DataEntryStep3 } from "./data-entry-step-3/data-entry-step-3";
import { DataEntryStep4 } from "./data-entry-step-4/data-entry-step-4";
import { DataEntryStep5 } from "./data-entry-step-5/data-entry-step-5";
import { Agency, Formik, FormikInsurance } from "src/types";
import { AnyObjectSchema } from "yup";

export const DataEntry = ({
  currentStep,
  insuranceFormik,
  validationSchema,
}: {
  currentStep: number;
  insuranceFormik: Formik<FormikInsurance>;
  validationSchema: AnyObjectSchema;
  agency: Agency | undefined;
}) => {
  const {
    evaluating,
    evaluatedPremium,
    continueDisabled,
    t,
    evaluatePremium,
    triggerFormikCheck,
  } = useDataEntry({ currentStep, insuranceFormik });

  const { values, handleSubmit } = insuranceFormik;

  const SubmitButton = (
    <div className="col-12 pl-md-3 mb-2 pt-4 pt-md-0 mb-md-1">
      {currentStep < 2 && (
        <div className="d-md-flex justify-content-center justify-content-md-between">
          <div>
            <div className="pe-md-4 mb-4 mb-md-0 d-flex d-md-block justify-content-center">
              <Button
                classes="primary d-flex justify-content-center button-submit m-md-0"
                classesText="font-medium-s text-uppercase"
                iconSize={20}
                text={t("data_entry_step_1.evaluate")}
                onPress={evaluatePremium}
                disabled={
                  !values?.insuredPeriodType ||
                  values?.insuredNumber === undefined ||
                  values?.insuredNumber === "" ||
                  Number(values?.insuredNumber) <= 0 ||
                  !values?.insuredPeriodType ||
                  !values.insuredDaysNumber ||
                  values?.insuredDaysNumber === undefined ||
                  Number(values?.insuredDaysNumber) <= 0 ||
                  !!insuranceFormik.errors.insuredDaysNumber
                }
              />
            </div>
          </div>
          <div>
            <Button
              type="submit"
              text={t("commons.continue")}
              classes="primary d-flex justify-content-center button-submit m-md-0"
              classesText="font-medium-s text-uppercase"
              iconSize={20}
              iconRight={RightArrowIcon}
              disabled={continueDisabled}
              onPress={triggerFormikCheck}
            />
          </div>
        </div>
      )}
    </div>
  );

  const Form = (
    <>
      {currentStep === 0 && (
        <DataEntryStep1
          validationSchema={validationSchema}
          formik={insuranceFormik}
        />
      )}
      {currentStep === 1 && (
        <DataEntryStep2
          validationSchema={validationSchema}
          formik={insuranceFormik}
        />
      )}
      {currentStep === 2 && (
        <DataEntryStep3
          validationSchema={validationSchema}
          formik={insuranceFormik}
        />
      )}
      {currentStep === 3 && (
        <DataEntryStep4
          validationSchema={validationSchema}
          formik={insuranceFormik}
        />
      )}
      {currentStep === 4 && <DataEntryStep5 />}
    </>
  );

  const Total = currentStep <= 1 && (
    <div className="col-md-12 pl-md-3 mb-2 pt-4 pt-md-0 mb-md-1">
      <div className="col-md-6 d-block d-md-flex align-items-center mb-3 pe-md-3">
        <div className="col-md-5 col-md-5 mb-3 mb-md-0">
          <div className="d-md-block">
            {evaluating ? (
              <div className="m-auto d-flex justify-content-center mb-3">
                <Loader overlay />
              </div>
            ) : (
              evaluatedPremium?.premium?.quoteValue && (
                <div className="d-flex justify-content-center justify-content-md-start align-items-center">
                  <div>
                    <div className="font-18-semibold c-7f7f7f text-center ">
                      {t("data_entry.total")}
                    </div>
                    <div className="font-38-semibold text-center c-secondary">
                      <div>
                        {evaluatedPremium?.premium?.quoteValue !== undefined
                          ? evaluatedPremium?.premium?.quoteValue
                              .toFixed(2)
                              .replace(".", ",")
                          : "-"}{" "}
                        €
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      {Form}
      {Total}
      <div className="mt-5 mb-3 border-top" />
      {SubmitButton}
    </form>
  );
};
